<template>
  <footer class="">
    <div class="top-wrapper">
      <div class="content-w wrap" v-if="$route.path !== '/'">
        <img
          src="@/assets/footer-copyright.png"
          class="copyright"
          loading="lazy"
        />
      </div>
    </div>

    <img src="@/assets/svg/border-bottom.svg" class="border-bottom" />
    <div class="bottom-wrapper">
      <div class="content-w wrap wrap-2">
        <img src="@/assets/logo.png" class="logo" loading="lazy" />

        <div class="">
          <div class="link-wrapper">
            <a
              :href="personalData"
              target="_blank"
              class="mobile-button button"
              variant="primary"
              >Политика конфиденциальности</a
            >

            <a
              :href="rules"
              target="_blank"
              class="mobile-button button"
              variant="primary"
              >Правила акции</a
            >

            <a
              :href="termsOfUse"
              target="_blank"
              class="mobile-button button"
              variant="primary"
              >Юридическая информация</a
            >
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "FooterRegion",

  data: () => ({
    rules: "",
    personalData: "",
    termsOfUse: "",
  }),

  computed: {
    ...mapGetters({
      documents: "documents",
      storeRules: "rules",
      storePrivacyPolicy: "privacyPolicy",
      storePersonalData: "personalData",
      storeUserAgremeent: "userAgreement",
    }),

    home() {
      return this.$route.name === "home";
    },
  },

  mounted() {
    setTimeout(() => {
      this.rules = this.storeRules.url;
      this.personalData = this.storePersonalData.url;
      this.termsOfUse = this.storeUserAgremeent.url;
    }, 900);
  },

  methods: {},
};
</script>

<style scoped lang="scss">
footer {
  background-color: transparent;
  width: 100%;
  color: $white;
  font-family: $regular !important;
  text-align: left;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.button {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 66px;
  color: white;
  text-decoration: underline;
  font-family: $regular;
  font-weight: 400;
  transition: 0.5s all;
  padding: 0 !important;
  font-size: 20px !important;
  height: fit-content;
  width: fit-content;

  &:hover {
    opacity: 0.7;
  }

  &:last-child {
    margin-right: 0;
  }

  @media (max-width: 1200px) {
    margin-right: 26px;
    font-size: 18px !important;
  }

  @media (max-width: 999px) {
    font-size: 14px !important;
    text-align: center;
  }

  @media (max-width: 750px) {
    margin-right: 20px;
  }

  @media (max-width: 576px) {
    margin-bottom: 10px;
    margin-right: 0;
  }
}

.wrap-2 {
  @media (max-width: 1200px) {
    padding-left: 20px;
    padding-right: 20px;
  }
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 999px) {
    flex-direction: column;
  }
}

.link-wrapper {
  display: flex;
  align-items: center;

  @media (max-width: 576px) {
    flex-direction: column;
  }
}

.top-wrapper {
  display: flex;
  justify-content: center;

  @media (max-width: 999px) {
    padding: 0 20px;
  }

  @media (max-width: 576px) {
    padding: 0 10px;
  }
}

.bottom-wrapper {
  background-color: #00712f;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  height: 176px;
  justify-content: center;

  @media (max-width: 999px) {
    height: 95px;
    padding: 0 20px;
  }

  @media (max-width: 576px) {
    height: 210px;
    padding: 0 10px;
  }
}

.wrap {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 576px) {
    flex-direction: column;
    justify-content: center;
  }
}

.logo {
  max-height: 86px;

  @media (max-width: 1200px) {
    max-height: 71px;
  }

  @media (max-width: 999px) {
    max-height: 56px;
  }

  @media (max-width: 576px) {
    max-height: 47px;
    margin-bottom: 25px;
  }
}

.border-bottom {
  width: 100vw;
  height: 2px;
}

.copyright {
  width: 100%;
  margin-top: 51px;
  margin-bottom: 12px;

  @media (max-width: 999px) {
    margin-top: 30px;
  }

  @media (max-width: 576px) {
    margin-top: 22px;
  }
}

a {
  padding: 0 !important;
}
</style>
